import * as yup from "yup";

// Regex to test password
export const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

export const ValidateRadiologistInviteForm = yup.object().shape({
  firstName: yup.string().required("This field is required"),
  lastName: yup.string().required("This field is required"),
  email: yup
    .string()
    .email("This is not a valid email")
    .required("This field is required"),
  phoneNumber: yup
    .string()
    .trim()
    .matches(
      /^((?=.*[0-9])[- +()0-9]+){9,13}$/,
      "Phone number is not in correct format"
    )
    .required("This field is required"),
  // .number()
  // .typeError("This should be a number")
  // .min(8, "This should be a minimum of 8 characters")
  // .required("This field is required"),
  role: yup.string().required("This field is required"),
  password: yup
    .string()
    .min(8)
    .typeError("Password should be at least 8 characters")
    .matches(
      passwordRegex,
      "Must contain at least an uppercase, symbol and number"
    )
    .required("This field is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Please confrim your password"),
});
